import React, {
  Component,
} from 'react'
import {
  connect,
} from 'react-redux'
import thankyouDeknerd from '../../assets/thankyouDeknerd.png'
class reviewVerify extends Component {
  render () {
    const {
      slugName
    } = this.props
    return (
      <div>
        <div className="page-content container clear-fix">
          <div className="container-404">
          <img src={thankyouDeknerd} style={{ width: '80%', margin: '0 auto' }}/>
          <br/>
            <p ><span >ขอบคุณที่สมัครเป็นผู้สอนร่วมกับเรา <br/>ทางเราได้รับรายละเอียดของท่านเรียบร้อยแล้ว</span></p>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = ({
},
{
  match: {
    params: {
      slugName,
    },
  }},) => {
  return {
    slugName,
  }
}

export default connect(mapStateToProps, null)(reviewVerify)



// WEBPACK FOOTER //
// ./src/components/tutorRegister/reviewVerify.js